import { createFileRoute, notFound } from "@tanstack/react-router";

import { seo } from "@/lib/seo";
import { assertDraftRouteVisible } from "@/lib/draft-routes";
import { PagePlaceholder } from "@/components/site/PagePlaceholder";

export const Route = createFileRoute("/_lp/lp/$campaign")({
  // Draft route: 404s on the live domain, renders normally elsewhere. See src/lib/draft-routes.ts.
  beforeLoad: assertDraftRouteVisible,
  head: ({ params }) =>
    seo({
      title: "Campaign Landing Page",
      description: "A campaign landing page from LAA Concierge Consulting.",
      path: `/lp/${params.campaign}`,
      noindex: true,
    }),
  loader: ({ params }) => {
    // [SUPPLY: campaign configuration source]. No campaigns are defined yet.
    if (!params.campaign) throw notFound();
    return { campaign: params.campaign };
  },
  component: Page,
  errorComponent: () => (
    <PagePlaceholder title="This page didn't load" intro="Try refreshing the page." />
  ),
  notFoundComponent: () => (
    <PagePlaceholder title="Campaign not found" intro="This campaign doesn't exist or has ended." />
  ),
});

function Page() {
  const { campaign } = Route.useParams();
  return (
    <PagePlaceholder
      title="Campaign landing page"
      intro={`[SUPPLY: landing page copy for campaign "${campaign}"]`}
    />
  );
}
